import React from 'react';
import { Box, Typography, Stack, Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BLACK_HEX, YELLOW_COLOR_HEX, DARK_GRAY_HEX } from '../../../../theme';

// Import avatar images
import avatar1 from '../../../../assets/headshots/avatar1.png';
import avatar2 from '../../../../assets/headshots/avatar2.png';
import avatar3 from '../../../../assets/headshots/avatar3.png';
import avatar4 from '../../../../assets/headshots/avatar4.png';
import avatar5 from '../../../../assets/headshots/avatar5.png';

import StarIcon from '@mui/icons-material/Star';

const HIDE_AVATARS = false;

const RatingDisplay = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        px: 0,
        py: 0,
        borderRadius: 0,
        background: 'none',
        boxShadow: 'none',
        minHeight: 0,
        minWidth: 0,
        mt: 1,
      }}
    >
      {/* First line: 4.8 and stars */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.2 }}>
        <Box
          component='img'
          src={require('../../../../assets/laurel_left.png')}
          sx={{
            width: {
              xs: 22,
              sm: 24,
              md: 26,
              lg: 28,
            },
            height: {
              xs: 22,
              sm: 24,
              md: 26,
              lg: 28,
            },
            objectFit: 'contain',
            mx: 0.2,
            filter: 'brightness(0)',
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            mx: 0.5,
            color: BLACK_HEX,
            fontSize: {
              xs: '1.4rem',
              sm: '1.6rem',
              md: '1.8rem',
              lg: '2rem',
            },
            lineHeight: 1,
          }}
        >
          4.8
        </Typography>
        <Box
          component='img'
          src={require('../../../../assets/laurel_right.png')}
          sx={{
            width: {
              xs: 22,
              sm: 24,
              md: 26,
              lg: 28,
            },
            height: {
              xs: 22,
              sm: 24,
              md: 26,
              lg: 28,
            },
            objectFit: 'contain',
            mx: 0.2,
            filter: 'brightness(0)',
          }}
        />
        <Stack direction='row' spacing={0.2} sx={{ ml: 0.5 }}>
          {[...Array(5)].map((_, index) => (
            <StarIcon
              key={index}
              sx={{
                color: YELLOW_COLOR_HEX,
                fontSize: {
                  xs: '1.4rem',
                  sm: '1.6rem',
                  md: '1.8rem',
                  lg: '2rem',
                },
              }}
            />
          ))}
        </Stack>
      </Box>
      {/* Second line: avatars and ratings */}
      {!HIDE_AVATARS && (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.2 }}>
          {[avatar1, avatar2, avatar3, avatar4, avatar5].map((src, idx) => (
            <Avatar
              key={src}
              src={src}
              sx={{
                width: {
                  xs: 18,
                  sm: 20,
                  md: 22,
                  lg: 24,
                },
                height: {
                  xs: 18,
                  sm: 20,
                  md: 22,
                  lg: 24,
                },
                border: '1.5px solid white',
                ml: idx === 0 ? 0 : -0.7,
                display: {
                  xs: idx < 3 ? 'flex' : 'none',
                  sm: idx < 3 ? 'flex' : 'none',
                  md: idx < 4 ? 'flex' : 'none',
                  lg: 'flex',
                },
              }}
            />
          ))}
          <Typography
            sx={{
              ml: 0.5,
              color: DARK_GRAY_HEX,
              fontSize: {
                xs: '0.85rem',
                sm: '0.9rem',
                md: '0.95rem',
                lg: '1rem',
              },
              whiteSpace: 'nowrap',
            }}
          >
            {t('xRatings', { count: 4600 })}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default RatingDisplay;
